import { WHITE } from "../../styles/colors"

const PlusIcon = ({
    color = WHITE,
    size = 8
}: {
    color?: string
    size?: number
}) => {
    return (
        <svg width={size} height={size} viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M3.50008 0.820312C3.86827 0.820312 4.16675 1.10504 4.16675 1.45627V3.36413L6.16675 3.36413C6.53494 3.36413 6.83341 3.64885 6.83341 4.00008C6.83341 4.35131 6.53494 4.63603 6.16675 4.63603H4.16675V6.5439C4.16675 6.89512 3.86827 7.17985 3.50008 7.17985C3.13189 7.17985 2.83341 6.89512 2.83341 6.5439V4.63603H0.833415C0.465225 4.63603 0.166748 4.35131 0.166748 4.00008C0.166748 3.64885 0.465225 3.36413 0.833415 3.36413L2.83341 3.36413V1.45627C2.83341 1.10504 3.13189 0.820312 3.50008 0.820312Z" fill={color}/>
        </svg>
    )
}

export default PlusIcon
